import api from "../api";

const state = {

};

const getters =  {

};

const mutations = {

};

const actions = {
    loadLiquidacionsNPN({commit}, npn){
        return api.predial.liquidacion(npn);
    },
    loadPdfLiquidacion({commit}, codLiq){
        return api.predial.pdfLiquidacion(codLiq);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};